import React from "react";
import KuikaButton from "../../../../ui-kit/kuika-button/kuika-button";
import KuikaOnboardingTooltip, {
  IOnboardingStep
} from "../../../../ui-kit/kuika-onboarding-tooltip/kuika-onboarding-tooltip";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

const STEPS: IOnboardingStep[] = [
  { header: "Welcome", label: "Drag any component from the catalogue onto the canvas to start." },
  { header: "Bind data", label: "Use the right-panel binder to connect properties to datasources." },
  { header: "Generate", label: "Hit Generate to compile to React, .NET, Android and iOS at once." }
];

export const OnboardingTooltipStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Onboarding Tooltip"
      componentName="KuikaOnboardingTooltip"
      sourcePath="ui-kit/kuika-onboarding-tooltip"
      description="Coach-mark surface used in first-run experiences. Single label, multi-step walkthrough, icons and configurable trigger types."
    >
      <SpecRow label="Hover trigger" caption="triggerType='hover' — closes on leave">
        <KuikaOnboardingTooltip
          header="Component catalogue"
          label="Browse every available component grouped by category."
          triggerType="hover"
        >
          <KuikaButton type="secondary">Hover me</KuikaButton>
        </KuikaOnboardingTooltip>
      </SpecRow>
      <SpecRow label="Click trigger" caption="triggerType='click'">
        <KuikaOnboardingTooltip header="Quick tip" label="Click anywhere outside to dismiss." triggerType="click">
          <KuikaButton type="secondary">Click me</KuikaButton>
        </KuikaOnboardingTooltip>
      </SpecRow>
      <SpecRow label="Multi-step walkthrough" caption="steps[] — pager UI is automatic">
        <KuikaOnboardingTooltip steps={STEPS} triggerType="click">
          <KuikaButton type="primary">Start tour</KuikaButton>
        </KuikaOnboardingTooltip>
      </SpecRow>
      <SpecRow label="Position">
        {(["top", "right", "bottom", "left"] as const).map((position) => (
          <KuikaOnboardingTooltip
            key={position}
            header={position}
            label="Pinned position."
            triggerType="click"
            position={position}
          >
            <KuikaButton type="secondary" size="sm">
              {position}
            </KuikaButton>
          </KuikaOnboardingTooltip>
        ))}
      </SpecRow>
    </ShowcaseFrame>
  );
};
